var m = require('mithril');
var moment = require('moment');
var c3 = require('../../libs/chart');

var chartInstanceId = 0;

var agentHistoryChart = {};

agentHistoryChart.oninit = function (vnode) {
  this.chart = null;
  this.signature = null;
  this.idDiv = vnode.attrs.chartId || ('agent-history-chart-' + (++chartInstanceId));
};

agentHistoryChart.onupdate = function (vnode) {
  var config = buildConfig(vnode.attrs || {});
  if (!this.chart || this.signature === config.signature) return;

  this.signature = config.signature;
  this.chart.load(Object.assign({ unload: true }, config.options.data));
  this.chart.resize();
};

agentHistoryChart.onremove = function () {
  if (this.chart && typeof this.chart.destroy === 'function') {
    this.chart.destroy();
  }
};

agentHistoryChart.view = function (vnode) {
  var ctrl = this;
  var attrs = vnode.attrs || {};
  var config = buildConfig(attrs);

  return m('div.agent-history-panel', [
    m('div.agent-history-panel-title.mb2', [
      m('div', [
        m('div.f4', attrs.title),
        m('div.f6.moon-gray', attrs.subtitle),
      ]),
      m('div.f6.moon-gray.tr.agent-history-latest', latestSeriesValue(config.series, config.valueFormatter)),
    ]),
    config.hasData
      ? m('div.agent-history-chart', [
        m(c3, {
          idDiv: ctrl.idDiv,
          resize: true,
          options: config.options,
          oncreate: function (chartVnode) {
            ctrl.chart = chartVnode.state.chart;
            ctrl.signature = config.signature;
          },
        }),
      ])
      : m('div.f5.mid-gray.mt4', 'No history samples.'),
  ]);
};

function buildConfig(attrs) {
  var series = buildSeries(attrs.history, attrs.series);
  var valueFormatter = typeof attrs.valueFormatter === 'function' ? attrs.valueFormatter : formatNumber;
  var columns = [];
  var xs = {};
  var colors = {};
  var types = {};

  series.forEach(function (line) {
    var xKey = line.label + ' x';
    xs[line.label] = xKey;
    colors[line.label] = line.color;
    types[line.label] = 'spline';
    columns.push([xKey].concat(line.points.map(function (point) {
      return new Date(point.time);
    })));
    columns.push([line.label].concat(line.points.map(function (point) {
      return point.value;
    })));
  });

  return {
    series: series,
    hasData: series.some(function (line) { return line.points.length > 0; }),
    signature: JSON.stringify(columns),
    valueFormatter: valueFormatter,
    options: {
      size: {
        height: 220,
      },
      legend: {
        position: 'inset',
      },
      grid: {
        y: {
          show: true,
        },
      },
      padding: {
        right: 10,
      },
      point: {
        show: false,
      },
      tooltip: {
        show: true,
        format: {
          title: function (x) {
            return moment(x).format('MM/DD/YYYY h:mm A');
          },
          value: function (value) {
            return valueFormatter(value);
          },
        },
      },
      data: {
        xs: xs,
        columns: columns,
        colors: colors,
        types: types,
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            fit: true,
            count: 4,
            format: function (x) {
              return moment(x).format('h:mm A');
            },
          },
        },
        y: {
          min: 0,
          padding: {
            bottom: 0,
          },
          tick: {
            count: 4,
            format: function (value) {
              return valueFormatter(value);
            },
          },
        },
      },
    },
  };
}

function buildSeries(history, specs) {
  return (specs || []).map(function (spec) {
    var source = history && history.series && history.series[spec.key] ? history.series[spec.key] : {};
    var points = (source.points || []).map(function (point) {
      var value = Number(point && point.value);
      if (typeof spec.transform === 'function') value = spec.transform(value);
      return {
        time: Number(point && point.time),
        value: value,
      };
    }).filter(function (point) {
      return Number.isFinite(point.time) && Number.isFinite(point.value);
    });

    return {
      key: spec.key,
      label: spec.label,
      color: spec.color,
      points: points,
    };
  });
}

function latestSeriesValue(series, valueFormatter) {
  var values = (series || []).map(function (line) {
    var points = line && Array.isArray(line.points) ? line.points : [];
    var latest = points.length ? points[points.length - 1] : null;
    return latest && Number.isFinite(Number(latest.value))
      ? line.label + ' ' + valueFormatter(Number(latest.value))
      : null;
  }).filter(Boolean);

  if (!values.length) return '-';
  return values.join(' / ');
}

function formatNumber(value) {
  var n = Number(value);
  if (!Number.isFinite(n)) return '-';
  return String(Math.round(n));
}

module.exports = agentHistoryChart;
